import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import type { TAnalyticsCertificateStatusEnum } from '@onesource/schemas';
import type { FC } from 'react';
import { MdLockOutline, MdWorkspacePremium } from 'react-icons/md';

const COPY: Record<TAnalyticsCertificateStatusEnum, { title: string; body: string }> = {
  coming_soon: {
    title: 'Certificate',
    body: 'Your certificate will be available here once all requirements are complete.',
  },
  locked: {
    title: 'Certificate',
    body: 'Complete every requirement above to unlock your certificate.',
  },
  available: {
    title: 'Certificate',
    body: 'Congratulations — all requirements are complete.',
  },
};

/** Placeholder for the auto-generated certificate (generation lands in a later release). */
export const CertificateSection: FC<{ status: TAnalyticsCertificateStatusEnum }> = ({ status }) => {
  const copy = COPY[status];
  const Icon = status === 'available' ? MdWorkspacePremium : MdLockOutline;
  return (
    <Card
      variant="outlined"
      sx={{
        borderRadius: 2,
        p: { xs: 2, md: 3 },
        display: 'flex',
        alignItems: 'center',
        gap: 2,
        borderStyle: 'dashed',
      }}
    >
      <Box sx={{ color: theme => theme.palette.grey[500], display: 'flex', flexShrink: 0 }}>
        <Icon size={32} />
      </Box>
      <Box>
        <Typography sx={{ fontFamily: '"Fraunces", serif', fontWeight: 500, fontSize: 18, color: '#2e2e2d' }}>
          {copy.title}
        </Typography>
        <Typography variant="body2" sx={{ color: theme => theme.palette.grey[600] }}>
          {copy.body}
        </Typography>
      </Box>
    </Card>
  );
};
